const includesIgnoreCase = (text, text2) =>
  text.toLowerCase().includes(text2.toLowerCase())

export default function coresCelula(nome) {
  switch (true) {
    case includesIgnoreCase(nome, 'azul'):
      return '#1E90FF'
    case includesIgnoreCase(nome, 'amarel'):
      return '#FFD700'
    case includesIgnoreCase(nome, 'cinza'):
      return '#C0C0C0'
    case includesIgnoreCase(nome, 'laranja'):
      return '#FFA500'
    case includesIgnoreCase(nome, 'vermelh'):
      return '#F35048'
    case includesIgnoreCase(nome, 'marrom'):
      return '#8B4513'
    case includesIgnoreCase(nome, 'rox'):
      return '#800080'
    case includesIgnoreCase(nome, 'preto'):
      return '#000000'
    case includesIgnoreCase(nome, 'verde'):
      return '#228B22'
    case includesIgnoreCase(nome, 'rosa'):
      return '#FF69B4'
    default:
      return '#FFFF00'
  }
}



// WEBPACK FOOTER //
// ./src/Resolvers/coresCelula.js